import { render, staticRenderFns } from "./PosMainInput.vue?vue&type=template&id=6f227286&scoped=true&"
import script from "./PosMainInput.vue?vue&type=script&lang=js&"
export * from "./PosMainInput.vue?vue&type=script&lang=js&"
import style0 from "./PosMainInput.vue?vue&type=style&index=0&id=6f227286&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f227286",
  null
  
)

export default component.exports